import "./MarketingProductNavbar.css";
import React, { createRef } from "react";
import autobind from "autobind-decorator";
import includes from "lodash/includes";
import PropTypes from "prop-types";
import { URLS } from "util/constants";
import { observable } from "mobx";

const DEFAULT_CLASS = "marketing-product-navbar";
const FIXED_UNDER_HEADER = DEFAULT_CLASS + " fixed-under-header";
const DEFAULT_DESKTOP_DISTANCE = 620;
const DEFAULT_TABLET_DISTANCE = 450;

class MarketingProductNavbar extends React.Component {
    @observable resetFixedHeaderPosition = -1;

    constructor(props) {
        super(props);

        this.productNavRef = createRef();
    }

    @autobind
    scrollHandler() {
        const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
        const fixedHeight = window.innerWidth < 800 ? (this.props.tabletTop || DEFAULT_TABLET_DISTANCE) : (this.props.desktopTop || DEFAULT_DESKTOP_DISTANCE);
        const classes = this.productNavRef.current.className;

        if (scrollTop >= fixedHeight && !includes(classes, "fixed-under-header")) {
            this.productNavRef.current.className = FIXED_UNDER_HEADER;
        } else if (scrollTop < fixedHeight && includes(classes, "fixed-under-header")) {
            this.productNavRef.current.className = DEFAULT_CLASS;
        }
    }

    componentDidMount() {
        window.onscroll = this.scrollHandler;
    }

    componentWillUnmount() {
        window.onscroll = null;
    }

    render() {
        return (
            <React.Fragment>
                <div ref={this.productNavRef} className={DEFAULT_CLASS}>
                    <input className="product-navbar-dropdown-input" type="checkbox" id="product-navbar-dropdown-input" aria-label="Product Navbar Dropdown" />
                    <label
                        className="product-navbar-dropdown-label"
                        htmlFor="product-navbar-dropdown-input"
                        aria-hidden="true"
                    >
                        VIEW ALL PRODUCTS
                    </label>
                    <div className="product-navbar-dropdown">
                        <a className="product-overview" href={URLS.MARKETING.PRODUCTS}>
                            <img alt="Gradifi Products Overview" className="product-overview-image" src={require("../assets/redesign2020/product-overview-border.png")} />
                            <span className="product-overview-body">
                                <span className="product-overview-title">Overview</span>
                                <span className="product-description">See the whole Gradifi suite of solutions.</span>
                            </span>
                        </a>
                        <a className="product-fincore" href={URLS.MARKETING.REFI}>
                            <img alt="Financial Core" className="fincore-image" src={require("../assets/redesign2020/fincore-border-logo.png")} />
                            <span className="fincore-body">
                                <span className="fincore-title">FinancialCore</span>
                                <span className="fincore-description">Empower your employees with tools and resources.</span>
                            </span>
                        </a>
                        <a className="product-slp" href={URLS.MARKETING.PAYDOWN}>
                            <img alt="Student Loan Paydown" className="slp-image" src={require("../assets/redesign2020/slp-border-logo.png")} />
                            <span className="slp-body">
                                <span className="slp-title">Student Loan PayDown</span>
                                <span className="slp-description">Help employees pay down student loans.</span>
                            </span>
                        </a>
                        <a className="product-csu" href={URLS.MARKETING.SAVEUP}>
                            <img alt="College SaveUp" className="csu-image" src={require("../assets/redesign2020/csu-border-logo.png")} />
                            <span className="csu-body">
                                <span className="csu-title">College SaveUp</span>
                                <span className="csu-description">Offer employees solutions to save for their children's education.</span>
                            </span>
                        </a>
                    </div>
                </div>
                <div className="marketing-navbar-spaceholder" aria-hidden="true" />
            </React.Fragment>
        );
    }
}

MarketingProductNavbar.propTypes = {
    tabletTop: PropTypes.number,
    desktopTyop: PropTypes.number
};

export default MarketingProductNavbar;